import React from 'react';
import cx from 'classnames';

import { MDText } from 'i18n-react';

import { InfoBox } from '@motorway/mw-highway-code/alpha';

import { useWizard } from '../../fastlane/wizard/Wizard.helpers';
import LocalTexts from '../VehicleProfilingTexts.json';

import styles from './MandatoryInfoBox.module.scss';

const LocalT = new MDText(LocalTexts);

export const MandatoryInfoBox = () => {
  const { showMandatoryInfoBox } = useWizard();
  const { errorInfoBoxContent, errorInfoBoxExtraMargin, visible } = showMandatoryInfoBox || {};
  if (!visible) {
    return null;
  }

  return (
    <div className={cx(styles.container, { [styles.extraMargin]: errorInfoBoxExtraMargin })}>
      <InfoBox content={errorInfoBoxContent ?? LocalT.translate('mandatoryInfoBox.content')} data-cy='cannotSkip' heading={LocalT.translate('mandatoryInfoBox.title')} variant="error" />
    </div>
  );
};
